import * as S from './styles';

export function ProductWarnings({ productName, farmacia }) {
  return (
    <S.Container className="product-warnings">
      <div>
        SE PERSISTIREM OS SINTOMAS, O MÉDICO DEVERÁ SER CONSULTADO.
        {!!farmacia.advertenciaMS && '<br />' && farmacia.advertenciaMS}
        {productName.toUpperCase()} É UM MEDICAMENTO. SEU USO PODE TRAZER
        RISCOS. PROCURE UM MÉDICO E O FARMACÊUTICO. LEIA A BULA.
      </div>
    </S.Container>
  );
}
